import axios from 'axios';
import {
  Configuration,
  AdminSalesChannelsApiFactory,
  SalesChannelItemsApiFactory,
  AdminCountriesApiFactory,
  AdminExternalProductsApiFactory,
  AdminMaterialsApiFactory,
  AdminProductPricesApiFactory,
  AdminProductsApiFactory,
  AdminProductVariantsApiFactory,
  AdminTagsApiFactory,
  LocalesApiFactory,
  PropertiesApiFactory,
  SalesChannelsApiFactory,
  AdminBundleAcquisitionPricesApiFactory,
  AdminBundlePricesApiFactory,
  AdminBundlesApiFactory,
  AdminCategoriesApiFactory,
  AdminPriceRefreshRequestsApiFactory,
  AdminTeliaFinanceProductsApiFactory,
  AdminBrandsApiFactory,
} from '@cdaas/api-clients/dist/product-service-openapi';

const productServiceConfig = new Configuration({
  basePath: process.env.REACT_APP_PRODUCT_SERVICE_URL,
});

export const productServiceAdminSalesChannelsClient = AdminSalesChannelsApiFactory(productServiceConfig, undefined, axios);
export const productServiceSalesChannelsClient = SalesChannelsApiFactory(productServiceConfig, undefined, axios);
export const productServiceSalesChannelItemsClient = SalesChannelItemsApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminBrandsClient = AdminBrandsApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminCategoriesClient = AdminCategoriesApiFactory(productServiceConfig, undefined, axios);
export const productServiceCountriesClient = AdminCountriesApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminProductsClient = AdminProductsApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminProductVariantsClient = AdminProductVariantsApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminProductPricesClient = AdminProductPricesApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminMaterialsClient = AdminMaterialsApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminTagsClient = AdminTagsApiFactory(productServiceConfig, undefined, axios);
export const productServicePropertiesClient = PropertiesApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminExternalProductsClient = AdminExternalProductsApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminBundlePricesClient = AdminBundlePricesApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminBundlesClient = AdminBundlesApiFactory(productServiceConfig, undefined, axios);
export const productServiceLocalesClient = LocalesApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminBundleAcquisitionPricesClient = AdminBundleAcquisitionPricesApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminTeliaFinanceProductsClient = AdminTeliaFinanceProductsApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminPriceRefreshRequestsClient = AdminPriceRefreshRequestsApiFactory(productServiceConfig, undefined, axios);
